export enum FaceToFaceDdAction {
  ClickReservationStart = 'f2f-click-reservationStart',
  ClickDepartment = 'f2f-click-department',
  ClickDate = 'f2f-click-date',
  ClickTimeLine = 'f2f-click-timeLine',
  ClickDoctor = 'f2f-click-doctor',
  ClickReservationComplete = 'f2f-click-reservationComplete',
  CloseErrorModal = 'f2f-close-errorModal',
  ClickReservationStartWithNoAuth = 'f2f-click-reservationStart-noauth',
  ClickCallReservation = 'f2f-click-call-reservation',
  ClickCallReservationPartner = 'f2f-click-call-reservationPartner',
  ClickCallHospital = 'f2f-click-call-hospital',
  PageViewHospitalDetail = 'f2f-pageview-hospitalDetail',
  ClickEventButton = 'f2f-click-event-button',
}
